<template>
	<div class="menu-item-picker font-color-formatting">
		<v-menu absolute right bottom :close-on-content-click="false" content-class="c_menu" v-model="isMenuOpen">
			<template v-slot:activator="{ on, attrs }">
				<div v-bind="attrs" v-on="on">
					<FontColorSvg />
				</div>
			</template>
			<div class="px-2 py-2">
				<InputColorPicker :color.sync="color" />
			</div>
		</v-menu>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';

import TiptapService from '../../tiptap-service';

import InputColorPicker from '@/components/common/InputColorPicker';
import FontColorSvg from './assets/FontColorSvg';

const defaultColor = '#FFFFFF';

const throttledSetColor = throttle((editor, newColor) => {
	editor.commands.setColor(newColor);
}, 50);

export default {
	name: 'FontColorFormatting',
	components: {
		InputColorPicker,
		FontColorSvg,
	},
	props: {
		editor: { type: Object },
		selectionObj: { type: Object },
	},
	watch: {
		color: {
			handler(newV) {
				if (this.isMenuOpen && newV && newV) {
					console.log('**** color: ', newV);
					throttledSetColor(this.editor, newV.hex ? newV.hex : newV);
				}
			},
		},
		selectionObj: {
			handler(newV) {
				if (!this.isMenuOpen && newV) {
					const fontColor = TiptapService.getFontColor(this.editor);
					this.color = fontColor === 'contains_more_than_one_style' ? undefined : fontColor || defaultColor;
				}
			},
		},
	},
	data() {
		return {
			color: null,
			isMenuOpen: false,
		};
	},
};
</script>

<style lang="scss" scoped>
.font-color-formatting {
	margin-top: 2px;
}
</style>
